import { render, staticRenderFns } from "./SuccesSingDocument.vue?vue&type=template&id=278bddf3&scoped=true"
import script from "./SuccesSingDocument.vue?vue&type=script&lang=js"
export * from "./SuccesSingDocument.vue?vue&type=script&lang=js"
import style0 from "./SuccesSingDocument.vue?vue&type=style&index=0&id=278bddf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278bddf3",
  null
  
)

export default component.exports